import { Component, OnInit } from '@angular/core';
import {ConexionesService} from '../../services/conexiones.service'
import { ActivatedRouteSnapshot, NavigationEnd, Router } from '@angular/router';
import { AiService } from '../../services/ollama.service';




@Component({
  selector: 'app-inicio',
  templateUrl: './inicio.component.html',
  styleUrls: ['./inicio.component.css']
})
export class InicioComponent implements OnInit {
  
  forma = {
    nombre:""
  }
  noticiasBanner:any;
  nombreDia:any;
  nombreMes:any;
  clima: any;
  icon: any;
  temp: any;
  numerodiaMes:any
  mySubscription:any;

  postnld = {
    titulo :"",
    imagen:"",
    descripcion:""
  }
  turismonld = {
    titulo: "",
    imagen: "",
    descripcion: ""
  }
  desarrollonld = {
    titulo: "",
    imagen: "",
    descripcion: ""
  }
  artenld = {
    titulo: "",
    imagen: "",
    descripcion: ""
  }


  //opciones
    
    postNld=true;
    postTurismo=false;
    archivoHistorico=false;
    arteycultura=false;
    desarrolloEconomico=false
    red = false;



    /*-nuevas variables busqueda-*/
    searchQuery: string = '';

  // Propiedades del carousel
  currentIndex = 0;
  currentTranslate = 0;
  slidesToShow = 4; // Número de slides visibles
  dots: number[] = [];
  autoplayInterval: any;
  autoplayDelay = 10000; // 3 segundos

  // Propiedades del modal
  modalAbierto = false;
  anuncioSeleccionado: any = null;


  isMenuOpen: boolean = false;

  // Array de anuncios - Estructura COMPLETA
  anuncios = [
     {
      id: 1,
      titulo: 'CONVOCATORIA BECA JUNTOS POR EL DESARROLLO CULTURAL 2026',
      imagen: 'https://nld.gob.mx/assets/img/convocatoria22.jpg',
      botonTexto: ' Ingresa aquí para aplicar ',
      botonUrl: 'https://nld.gob.mx/varios?id=convocatoria1',
      redireccionDirecta: true,
      url: 'https://nld.gob.mx/varios?id=convocatoria1',
      botonTarget: '_blank', // '_blank' = nueva pestaña, '_self' = misma pestaña
    },
    {
      id: 2,
      titulo: 'Programa de Apoyo al Trabajo Docente 2026',
      imagen: 'https://nld.gob.mx/assets/img/docente/docente.jpg',
      botonTexto: ' Ingresa aquí para aplicar ',
      botonUrl: 'https://nld.gob.mx/varios?id=docente',
      redireccionDirecta: true,
      url: 'https://nld.gob.mx/varios?id=docente',
      botonTarget: '_blank', // '_blank' = nueva pestaña, '_self' = misma pestaña
    },
    {
      id: 3,
      titulo: 'Consulta el estatus de tu Beca',
      imagen: 'https://nld.gob.mx/assets/img/estatusbeca.jpg',
      // Botón opcional - Si no necesita botón, omitir estas 3 propiedades
      botonTexto: 'Consulta el estatus de tu Beca',
      botonUrl: 'https://nld.gob.mx/becas',
      url: 'https://nld.gob.mx/becas',
      redireccionDirecta: true,
      botonTarget: '_blank' // '_blank' = nueva pestaña, '_self' = misma pestaña
    },
 /*   {
    id: 3,
    titulo: '¡Así luce el clima esta semana en nuestra ciudad!',
      imagen: "https://nld.gob.mx/assets/682332192_1397512829072984_1291484465397134088_n.jpg",
    botonTexto: '',
    botonUrl: '',
    botonTarget: '',
     redireccionDirecta: false,
  },*/
    {
      id: 4,
      titulo: 'Convocatoria Impulso Económico',
      imagen: 'https://nld.gob.mx/assets/img/imagenC2.png',
      // Botón opcional - Si no necesita botón, omitir estas 3 propiedades
      botonTexto: ' Ingresa aquí para aplicar ',
      botonUrl: 'http://solicitud.fondotamaulipas.gob.mx/Impulso/login',
      botonTarget: '_blank' // '_blank' = nueva pestaña, '_self' = misma pestaña
    },
    {
      id: 5,
      titulo: 'Pagos de Inscripciones de Prepas Municipales',
      imagen: 'https://nld.gob.mx/assets/img/pagosprepas.jpeg',
      botonTexto: '',
      url:"http://201.144.104.26/prepasnld/Ingresar.aspx",
      redireccionDirecta: true,
      botonUrl: '',
      botonTarget: ''
    },
     {
      id: 6,
       titulo: 'Consulta y Pago de Predial',
       imagen: 'https://nld.gob.mx/assets/img/predial_banner2.png',
       botonUrl: 'https://nld.gob.mx/predial',
       url: 'https://nld.gob.mx/predial',
       redireccionDirecta: true,
       botonTarget: '_blank' // '_blank' = nueva pestaña, '_self' = misma pestaña
    }
   
  ];
  /*
  anuncios2 = [
   
    {
      id: 4,
      titulo: 'Convocatoria Impulso Económico',
      imagen: 'https://nld.gob.mx/assets/img/imagenC2.png',
      // Botón opcional - Si no necesita botón, omitir estas 3 propiedades
      botonTexto: ' Ingresa aquí para aplicar ',
      botonUrl: 'http://solicitud.fondotamaulipas.gob.mx/Impulso/login',
      botonTarget: '_blank' // '_blank' = nueva pestaña, '_self' = misma pestaña
    },
    {
      id: 5,
      titulo: 'Pagos de Inscripciones de Prepas Municipales',
      imagen: 'https://nld.gob.mx/assets/img/pagosprepas.jpeg',
      botonTexto: '',
      url: "http://201.144.104.26/prepasnld/Ingresar.aspx",
      redireccionDirecta: true,
      botonUrl: '',
      botonTarget: ''
    },
    {
      id: 6,
      titulo: 'Monólogo Antígona González',
      imagen: 'https://nld.gob.mx/assets/anuncio6.jpeg',
      botonTexto: '',
      botonUrl: '',
      botonTarget: ''
    }

  ];*/
  // AGREGAR AL home.component.ts

  // Array de otros trámites
  otrosTramites: any[] = [
    {
      nombre: 'Notificación por Estrados de la Dirección de Ejecución Fiscal',
      url: 'https://estrados.nld.gob.mx',
      target: '_self',
      icono: 'bi bi-people'
    },
    {
      nombre: 'Bolsa de Empleo Municipal Inteligente',
      url: 'https://www.bolsadeempleo.com.mx/bolsadeempleo',
      target: '_self',
      icono: 'bi bi-graph-up'
    },
    {
      nombre: 'Indicadores de desempeño',
      url: 'https://nld.gob.mx/varios?id=capacitacion',
      target: '_self',
      icono: 'bi bi-graph-up'
    },

    {
      nombre: 'Resultados de servicios Públicos Municipales',
      url: '/resultados',
      target: '_self',
      icono: 'bi bi-clipboard-data'
    },
    {
      nombre: 'COPLADEM',
      url: 'https://copladem.nld.gob.mx/',
      target: '_blank',
      icono: 'bi bi-diagram-3'
    },
    {
      nombre: 'INVEST',
      url: 'https://invest.nld.gob.mx/',
      target: '_blank',
      icono: 'bi bi-cash-stack'
    },
    {
      nombre: 'DIF NUEVO LAREDO',
      url: 'https://dif.nld.gob.mx/',
      target: '_blank',
      icono: 'bi bi-people'
    }
  ];
  // Propiedades para políticas
  modalPoliticaAbierto = false;
  politicaSeleccionada: any = null;
  tabActivo = 0; // Para la opción 2 (tabs)

  // Array de políticas
  // Políticas Institucionales
  politicaMision: any = {
    nombre: 'Misión',
    imagen: 'https://nld.gob.mx/assets/img/mision.jpg'
  };

  politicaVision: any = {
    nombre: 'Visión',
    imagen: 'https://nld.gob.mx/assets/img/vision.jpg'
  };

  politicaCalidad: any = {
    nombre: 'Política de Calidad',
    imagen: 'https://nld.gob.mx/assets/img/politica_calidad.png'
  };

  politicaAmbiental: any = {
    nombre: 'Política Ambiental',
    imagen: 'https://nld.gob.mx/assets/img/politica_ambiental.png'
  };

  politicaOrganigrama: any = {
    nombre: 'Organigrama',
    imagen: 'https://nld.gob.mx/assets/img/organigrama.jpg'
  };

  tramites=[]
  arregloFiltrado: any[] = [];
  indiceSeleccionado: number = -1;



  bannerTop = {
    imagen: 'https://nld.gob.mx/assets/img/ciga.png',
    alt: 'Banner CIGA',
    url: 'https://072.mx/', // Ajusta la URL destino
    target: '_blank' // '_blank' = nueva pestaña, '_self' = misma pestaña
  };

  banner: any = {
    url: 'https://nld.gob.mx/diga',
    target: '_blank',
    imagen: 'https://nld.gob.mx/assets/img/conimg1.jpg',
    alt: 'Banner DIGA'
  };

  modalVisible: boolean = false;  

  constructor(private db:ConexionesService,
    private router: Router, private ollamaService: AiService) { 
 
              }
 
  ngOnInit(): void {

    this.updateSlidesToShow();
    this.updateDots();
    this.startAutoplay();
    this.lazyLoadImages();

    // Actualizar slides visibles al cambiar tamaño de ventana
    window.addEventListener('resize', () => {
      this.updateSlidesToShow();
      this.updateDots();
      this.updateTranslate();
    });


    var ip = window.location.hostname;
    console.log(ip)
   
    const dias = [
      'Domingo',
      'Lunes',
      'Martes',
      'Miércoles',
      'Jueves',
      'Viernes',
      'Sábado',
    ];
    const numeroDia = new Date().getDay();
    const numerodiaMes = new Date().getDate();
    this.numerodiaMes = new Date().getDate();
    this.nombreMes = new Intl.DateTimeFormat('es-ES', { month: 'long' }).format(new Date());
    this.nombreDia = dias[numeroDia];
   

    this.db.getNoticiasLimit(11)
    .then((data:any)=>{
      console.log(data)
      this.noticiasBanner = data;
      console.log(this.noticiasBanner)
    })


    this.db.getTramites(500)
      .then((data: any) => {
        console.log(data)
        this.tramites = data;
       
      })


   /* this.db.getIp().then((resp)=>{
      let routeString = resp['connection'].route;
      this.red= routeString.includes('201.144');
      
    })*/
    
    this.db.getPosts().then((data: any) => {


      for(var i=0;i<data.length;i++){
      /*    if(data[i].idcategoria=="postNLD"){
            console.log(data[i])
            this.postnld = data[i]  ;
            console.log(this.postnld)
            let jsonClima = {
              id: 3,
              titulo: '¡Así luce el clima esta semana en nuestra ciudad!',
              imagen: "https://app.nld.gob.mx/assets/5e913401d6a55f1d2e3d59f74a047a69.jpg",
              botonTexto: '',
              botonUrl: '',
              botonTarget: ''
            }

            this.anuncios.push(jsonClima);
          }*/
        
        
      }
      console.log(this.postnld)
      
    })
 //   this.probar()
  }
  
  toggleMenu(): void {
    this.isMenuOpen = !this.isMenuOpen;
  }
/*
  habilitaPost(item){
      if(item=="turismo"){
        this.postTurismo=true;
        this.postNld=false;
        this.archivoHistorico=false;
        this.arteycultura=false;
        this.desarrolloEconomico = false;
      }
    if (item == "archivoHistorico") {
      this.postTurismo = false;
      this.postNld = false;
      this.archivoHistorico=true;
      this.arteycultura=false;
      this.desarrolloEconomico = false;
    }
    if (item == "arteycultura") {
      this.postTurismo = false;
      this.postNld = false;
      this.archivoHistorico = false;
      this.arteycultura = true;
      this.desarrolloEconomico = false;
    }
    if (item == "desarrolloEconomico") {
      this.postTurismo = false;
      this.postNld = false;
      this.archivoHistorico = false;
      this.arteycultura = false;
      this.desarrolloEconomico = true;
    }
    if (item == "gobierno") {
      this.postTurismo = false;
      this.postNld = true;
      this.archivoHistorico = false;
      this.arteycultura = false;
      this.desarrolloEconomico = false;
    }
   
  }
*/

  get todosLosAnuncios() {
    return this.anuncios;
  }

  // Función para abrir modal o redirigir
  abrirModal(anuncio: any): void {
    console.log('=== CLICK EN ANUNCIO ===');
    console.log('Anuncio:', anuncio);
    console.log('¿Tiene redireccionDirecta?', anuncio.redireccionDirecta);
    console.log('¿Tiene URL?', anuncio.url);

    if (anuncio.redireccionDirecta === true && anuncio.url) {
      console.log('→ REDIRIGIENDO A:', anuncio.url);
      if (anuncio.target === '_blank') {
        window.open(anuncio.url, '_blank');
      } else {
        window.location.href = anuncio.url;
      }
    } else {
      console.log('→ ABRIENDO MODAL');
      this.anuncioSeleccionado = anuncio;
      this.modalVisible = true;
      console.log('modalVisible ahora es:', this.modalVisible);
      console.log('anuncioSeleccionado ahora es:', this.anuncioSeleccionado);
    }
  }

  cerrarModal(): void {
    this.modalVisible = false;
    this.anuncioSeleccionado = null;
  }
  /*abrirModal(anuncio: any): void {
    console.log('Anuncio clickeado:', anuncio);
    console.log('¿Tiene redirección directa?', anuncio.redireccionDirecta);

    // Si tiene redirección directa y URL, redirigir
    if (anuncio.redireccionDirecta === true && anuncio.url) {
      console.log('Redirigiendo a:', anuncio.url);
      if (anuncio.target === '_blank') {
        window.open(anuncio.url, '_blank');
      } else {
        window.location.href = anuncio.url;
      }
    } else {
      console.log('Abriendo modal');
      // Si no tiene redirección directa, abrir el modal
      this.anuncioSeleccionado = anuncio;
      this.modalVisible = true;
      console.log('modalVisible:', this.modalVisible);
      console.log('anuncioSeleccionado:', this.anuncioSeleccionado);
    }
  }*/

  irNoticia(item:any){
    console.log(item)
     this.router.navigate(['/noticias'],{queryParams:item});
  }
  irNoticia2(){
    let item = {
      id:0
    }
    this.router.navigate(['/noticias'],{queryParams:item});
 }

  onKeydownEvent(){
    return false
  }

  varios(item) {
    console.log(item)
    if (item == "calidad") {
      let dato = {
        id: 'calidad'
      }
      this.router.navigate(['/varios'], { queryParams: dato });
    }
    if (item == "capacitacion") {
      let dato = {
        id: 'capacitacion'
      }
      this.router.navigate(['/varios'], { queryParams: dato });
    }
  }
  convocatoria(item){

    if(item==1){
      let dato = {
        id: 'convocatoria1'
      }
      this.router.navigate(['/varios'], { queryParams: dato });
    }
    if (item == 2) {
      let dato = {
        id: 'convocatoria2'
      }
      this.router.navigate(['/varios'], { queryParams: dato });
    }
    if (item == 3) {
      let dato = {
        id: 'convocatoria3'
      }
      this.router.navigate(['/varios'], { queryParams: dato });
    }

  }

  infBecas(){
    document.getElementById('infobecas').scrollIntoView({
      behavior: 'smooth'
    });
  }
  




  /*********nuevas funciones */

  onSearch(): void {
    if (this.searchQuery.trim()) {
      console.log('Buscando:', this.searchQuery);
      // Aquí implementarás la lógica de búsqueda
      // Por ejemplo, navegar a una página de resultados:
      // this.router.navigate(['/busqueda'], { queryParams: { q: this.searchQuery } });
    }
  }
  filtrar() {
    const texto = this.searchQuery.toLowerCase();

    this.arregloFiltrado = this.tramites.filter(item =>
      item.Nombre.toLowerCase().includes(texto)
    );

    this.indiceSeleccionado = -1; // reset al filtrar
  }

  manejarTeclas(event: KeyboardEvent) {
    if (!this.arregloFiltrado.length) return;

    switch (event.key) {
      case 'ArrowDown':
        event.preventDefault();
        this.indiceSeleccionado =
          (this.indiceSeleccionado + 1) % this.arregloFiltrado.length;
        break;

      case 'ArrowUp':
        event.preventDefault();
        this.indiceSeleccionado =
          this.indiceSeleccionado <= 0
            ? this.arregloFiltrado.length - 1
            : this.indiceSeleccionado - 1;
        break;

      case 'Enter':
        event.preventDefault();
        if (this.indiceSeleccionado >= 0) {
          this.seleccionar(this.arregloFiltrado[this.indiceSeleccionado]);
        }
        break;

      case 'Escape':
        this.arregloFiltrado = [];
        break;
    }
  }
  seleccionar(item: any) {
    this.searchQuery = item.Nombre;
    this.arregloFiltrado = [];

    const url = `http://201.144.104.26/nldretys/TramiteDetalle.aspx?Tra=${item.TramiteID}`;
    window.open(url, '_blank');
  }




  // Iniciar autoplay
  startAutoplay(): void {
    this.autoplayInterval = setInterval(() => {
      this.autoNextSlide();
    }, this.autoplayDelay);
  }

  // Detener autoplay
  stopAutoplay(): void {
    if (this.autoplayInterval) {
      clearInterval(this.autoplayInterval);
    }
  }

  // Reiniciar autoplay
  resetAutoplay(): void {
    this.stopAutoplay();
    this.startAutoplay();
  }

  // Avanzar automáticamente
  autoNextSlide(): void {
    const maxIndex = this.anuncios.length - this.slidesToShow;
    if (this.currentIndex < maxIndex) {
      this.currentIndex++;
    } else {
      // Volver al inicio cuando llega al final
      this.currentIndex = 0;
    }
    this.updateTranslate();
  }

  // Actualizar número de slides visibles según tamaño de pantalla
  updateSlidesToShow(): void {
    const width = window.innerWidth;
    if (width <= 576) {
      this.slidesToShow = 1;
    } else if (width <= 992) {
      this.slidesToShow = 2;
    } else if (width <= 1200) {
      this.slidesToShow = 3;
    } else {
      this.slidesToShow = 3; // Desktop también 3
    }
  }

  // Actualizar puntos indicadores
  updateDots(): void {
    const totalDots = Math.ceil(this.anuncios.length - this.slidesToShow + 1);
    this.dots = Array(totalDots > 0 ? totalDots : 1).fill(0).map((_, i) => i);
  }

  // Actualizar transform
  updateTranslate(): void {
    const slideWidth = 100 / this.slidesToShow;
    this.currentTranslate = -(this.currentIndex * slideWidth);
  }

  // Ir al slide anterior
  prevSlide(): void {
    if (this.currentIndex > 0) {
      this.currentIndex--;
      this.updateTranslate();
      this.resetAutoplay(); // Reiniciar autoplay al interactuar
    }
  }

  // Ir al siguiente slide
  nextSlide(): void {
    const maxIndex = this.anuncios.length - this.slidesToShow;
    if (this.currentIndex < maxIndex) {
      this.currentIndex++;
      this.updateTranslate();
      this.resetAutoplay(); // Reiniciar autoplay al interactuar
    }
  }

  // Ir a un slide específico
  goToSlide(index: number): void {
    this.currentIndex = index;
    this.updateTranslate();
    this.resetAutoplay(); // Reiniciar autoplay al interactuar
  }

  /*
  abrirModal(anuncio: any): void {
    this.anuncioSeleccionado = anuncio;
    this.modalAbierto = true;
    this.stopAutoplay(); // Detener autoplay cuando modal está abierto
   
    document.body.style.overflow = 'hidden';
  }*/
 

  /*
  cerrarModal(): void {
    this.modalAbierto = false;
    this.anuncioSeleccionado = null;
    
    this.startAutoplay(); 
   
    document.body.style.overflow = 'auto';
  }*/


  // Limpiar intervalo al destruir componente
  ngOnDestroy(): void {
    this.stopAutoplay();

    if (this.modalPoliticaAbierto) {
      document.body.style.overflow = 'auto';
    }
  }

  // OPCIONAL: Pausar autoplay al pasar el mouse
  onMouseEnter(): void {
    this.stopAutoplay();
  }

  // OPCIONAL: Reanudar autoplay al salir el mouse
  onMouseLeave(): void {
    this.startAutoplay();
  }


  // Abrir modal de política
  abrirPolitica(politica: any): void {
    this.politicaSeleccionada = politica;
    this.modalPoliticaAbierto = true;
    document.body.style.overflow = 'hidden';
  }

  // Cerrar modal de política
  cerrarPolitica(): void {
    this.modalPoliticaAbierto = false;
    this.politicaSeleccionada = null;
    document.body.style.overflow = 'auto';
  }

  // Cambiar tab (solo para opción 2)
  cambiarTab(index: number): void {
    this.tabActivo = index;
  }
  lazyLoadImages() {
    const images = document.querySelectorAll('img[data-src]');
    const imageObserver = new IntersectionObserver((entries) => {
      entries.forEach(entry => {
        if (entry.isIntersecting) {
          const img = entry.target as HTMLImageElement;
          img.src = img.dataset.src!;
          img.removeAttribute('data-src');
          imageObserver.unobserve(img);
        }
      });
    });

    images.forEach(img => imageObserver.observe(img));
  }
 
  

  probar() {
    this.ollamaService.generarTexto('Hola, ¿cómo estás?')
      .subscribe(resp => {
       
       console.log('Respuesta : ' + JSON.stringify(resp)); 
      });
  }

}